import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaBancosPagosEmpleadoPagoComponent {
  constructor ($q, $catalogos, $scope) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.$scope = $scope
    this.cuentaBancaria = null
    this.cuentasBancarias = []
    this.catalogo = {
      clientes: [],
      cuentasBancarias: [],
      formasPago: [
        {id: '01', descripcion: 'Transferencia'},
        {id: '02', descripcion: 'Cheque'},
        {id: '03', descripcion: 'Efectivo'},
        {id: '04', descripcion: 'Retención'},
        {id: '05', descripcion: 'Otro'},
      ],
    }
  }

  $onInit () {
    this.dataOriginal = Object.assign({}, this.data)
    this.promise = this.$q.all([
      this.$catalogos.get('clientes')
        .then((data) => (this.catalogo.clientes = data)),
      this.$catalogos.get('cuentasBancarias')
        .then((data) => {
          this.cuentasBancarias = data
          this.filtrarCuentas()
          this.cuentaBancaria = this.catalogo.cuentasBancarias.find((item) => item.ID_Cuenta === this.data.ID_Cuenta)
        }),
    ])
  }

  filtrarCuentas () {
    this.catalogo.cuentasBancarias = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.OP_ID_Empresa)
  }

  seleccionarCuenta () {
    if (this.cuentaBancaria) {
      this.data.Banco = this.cuentaBancaria.ID_Banco
      this.data.Moneda = this.cuentaBancaria.ID_Moneda
      this.data.ID_Cuenta = this.cuentaBancaria.ID_Cuenta
    }
  }

  actualizar () {
    this.onActualizar({$data: this.data})
  }

  eliminar () {
    this.onEliminar()
  }

  cancelar () {
    this.data = Object.assign({}, this.dataOriginal)
    this.onCerrar()
  }

  cerrar () {
    this.onCerrar()
  }
}

module.component('nominasNominaBancosPagosEmpleadoPago', {
  controller: NominasNominaBancosPagosEmpleadoPagoComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idEmpleado: '<',
    idNomina: '<',
    indice: '<',
    data: '<',
    procesando: '<',
    onActualizar: '&',
    onCerrar: '&',
    onEliminar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/empleado/pago/component.js